<div class="mmao">
  <div class="mmao__description">
    <p *ngIf="errorMessage" class="mmao__description__alert">{{ errorMessage }}</p>
    <ng-container *ngIf="negotiation">
      <p *ngIf="negotiation.nextActions && !negotiation.isAccepted">{{ negotiation.userMessage }}</p>
      <p *ngIf="negotiation.userSubMessage && negotiation.nextActions && !negotiation.isAccepted">
        {{ negotiation.userSubMessage }}
      </p>
      <p *ngIf="isLastOffer" class="mmao__description__alert" i18n="@@MMAO.POPIN.OTHER_MSG.RESPONSE_LAST_OFFER">
        Please note, this is your final offer.
      </p>
    </ng-container>
    <ng-container *ngIf="!negotiation">
      <ng-container *ngIf="userRole === 'buyer'; else wordingSeller" i18n="@@MMAO.POPIN.OTHER_MSG.START_NEGOTIATION">
        You would like to make the seller an offer on this item :
      </ng-container>
      <ng-template #wordingSeller i18n="@@MMAO.POPIN.OTHER_MSG.START_NEGOTIATION_SELLER">
        You would like to make an offer on this item :
      </ng-template>
    </ng-container>
  </div>

  <div class="mmao__innerWrapper">
    <!-- Product information -->
    <div class="mmao__product">
      <vc-images
        class="mmao__product__picture"
        [url]="'/produit/' + (product?.pictures)[0]?.path"
        [alt]="(product?.pictures)[0]?.alt"
        [width]="224"
        [height]="224"
      ></vc-images>
      <div class="mmao__product__description">
        <div class="mmao__product__description__name">{{ product.brand.name }}, {{ product.name }}</div>
        <div class="mmao__product__description__initialPrice" i18n="@@MMAO.POPIN.OTHER_MSG.INITIAL_PRICE">
          Starting price: {{ initialPrice.formatted }}
        </div>
      </div>
    </div>

    <div class="mmao__step">
      <div *ngIf="negotiation && (!negotiation.nextActions || negotiation.isAccepted)" class="mmao__status">
        <p>{{ negotiation.userMessage }}</p>
        <p>{{ negotiation.userSubMessage }}</p>
      </div>
      <div *ngIf="negotiation && negotiation.nextActions" class="mmao__status">
        <div *ngIf="negotiation?.lastEvent" class="mmao__status__lastEvent">
          <span class="mmao__status__userMessage">
            {{ negotiation.lastEvent.userMessage }} : <strong> {{ negotiation.lastEvent.price.formatted }} </strong>
          </span>
          <span *ngIf="userRole === 'seller'">
            <ng-container i18n="@@MMAO.POPIN.OTHER_MSG.FOR_YOU">For you:</ng-container>
            <strong class="mmao__status__price"> {{ negotiation.lastEvent.sellerPvnPrice.formatted }} </strong>
          </span>
        </div>
      </div>

      <div class="mmao__action" *ngIf="!negotiation || nextActions.length > 0">
        <!-- Available Actions -->
        <div>
          <ng-container *ngFor="let action of nextActions">
            <button
              *ngIf="action === 'reject'"
              class="vc-btn vc-btn--medium vc-btn--secondary mmao__action__button mmao__action__button--half"
              (click)="rejectOffer()"
              i18n="@@MMAO.CTA.REJECT_OFFER"
            >
              Decline
            </button>
            <button
              *ngIf="action === 'accept'"
              class="vc-btn vc-btn--medium vc-btn--primary mmao__action__button mmao__action__button--half"
              (click)="acceptOffer()"
              i18n="@@MMAO.CTA.ACCEPT_OFFER"
            >
              Accept
            </button>
            <button
              *ngIf="action === 'offer'"
              class="vc-btn vc-btn--medium vc-btn--secondary vc-btn--full mmao__action__button"
              (click)="selectAction(action)"
              i18n="@@MMAO.CTA.MAKE_COUNTER_OFFER"
            >
              Make a counter offer
            </button>
            <button
              *ngIf="action === 'order'"
              [appAddToCart]="negotiation.product"
              addToCartActive="hasLoader"
              class="vc-btn vc-btn--primary vc-btn--large vc-btn--full product__ctaBtn"
              [withPopin]="true"
              (click)="closePopin()"
            >
              <span *ngIf="negotiation.isAccepted" i18n="@@PRODUCT.DETAILS.CTA.BUY_WITH_PRICE"
                >Buy at {{ negotiation.price.formatted }}</span
              >
              <span *ngIf="!negotiation.isAccepted" i18n="@@PRODUCT.DETAILS.CTA.BUY">Add to bag</span>
            </button>
          </ng-container>
        </div>

        <!-- Form -->
        <vc-mmao-form
          [action]="currentAction"
          [currency]="currency"
          [min]="minOffer"
          [max]="maxOffer"
          [hasError]="!!errorMessage"
          [isLastOffer]="isLastOffer"
          (submitOffer)="submitOffer($event)"
          (cancelOffer)="clearAction()"
        ></vc-mmao-form>
      </div>
    </div>
  </div>

  <vc-mmao-history *ngIf="negotiation" class="mmao__history" [negotiation]="negotiation"></vc-mmao-history>
</div>
